// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import stat from '@infrastructure/shared/constant'
// ** Axios Imports
import axios from 'axios'

export const getGrade = createAsyncThunk('appInitialProjek/getGrade', async params => {
  const response = await axios.get(stat.URL_GRADE_KINDERGATEN, { params })
  return {
    data: response.data
  }
})

export const getGradeKelas = createAsyncThunk('appNilaiCk/getGradeKelas', async (kode_grade, {params, getState })  => {
  const response = await axios.get(stat.URL_KELAS + kode_grade, { params })
  console.log('current state:', getState())
  return response.data
})


export const getGuru = createAsyncThunk('appInitialProjek/getGuru', async params => {
  const add_url = "list"
  const response = await axios.get(stat.URL_GURU + add_url, { params })
  console.log(response.data)
  return response.data
})

export const getTemaByKodeGrade = createAsyncThunk('appInitialProjek/getTemaByKodeGrade', async (kode_grade, {params, getState })  => {
  const add_url = "tema/"
  const response = await axios.get(stat.URL_PROJEK + add_url +  kode_grade, { params })
  console.log('current state:', getState())
  return response.data
})

export const getProjekByKodeGrade = createAsyncThunk('appInitialProjek/getProjekByKodeGrade', async (kode_grade, {params, getState })  => {
  const add_url = "list/"
  const response = await axios.get(stat.URL_PROJEK + add_url + kode_grade, { params })
  console.log('current state:', getState())
  console.log(response.data)
  return response.data
})

export const putProjekKeterangan = createAsyncThunk('appInitialProjek/putProjekKeterangan', async (request, { dispatch, getState }) => {
  const add_url = "keterangan/"
  const response = await axios.put(stat.URL_PROJEK + add_url + request.id, request.payload)
  // console.log(getState().initialprojek.kodeGrade)
  await dispatch(getProjekByKodeGrade(getState().initialprojek.kodeGrade))
  return response.data
})

export const putProjekProfil = createAsyncThunk('appInitialProjek/putProjekProfil', async (request, { dispatch, getState }) => {
  const add_url = "profil/"
  const response = await axios.put(stat.URL_PROJEK + add_url + request.id, request.payload)
  // console.log(getState().initialprojek.kodeGrade)
  await dispatch(getProjekByKodeGrade(getState().initialprojek.kodeGrade))
  return response.data
})


// Dimensi Indikator
export const getProjekDimensiIndikator = createAsyncThunk('appInitialProjek/getProjekDimensiIndikator', async (kode_grade, {params, getState })  => {
  const add_url = "dimensi-indikator/"
  const response = await axios.get(stat.URL_PROJEK + add_url + kode_grade, { params })
  console.log('current state:', getState())
  console.log(response.data)
  return response.data
})


export const getSiswaList = createAsyncThunk('appInitialProjek/getSiswaList', async (kode_grade, {params})  => {
  const add_url = "list/"
  const response = await axios.get(stat.URL_SISWA + add_url + kode_grade, { params })
  return response.data
})

export const getProjekMember = createAsyncThunk('appInitialProjek/getProjekMember', async (id) => {
  const add_url = "member/"
  const response = await axios.get(stat.URL_PROJEK + add_url + id)
  return response.data
})

export const putProjekMember = createAsyncThunk('appInitialProjek/putProjekMember', async (request, {dispatch, getState}) => {
  const add_url = "member/"
  const response = await axios.put(stat.URL_PROJEK + add_url + request.id, request.payload)
  await dispatch(getProjekMember(getState().initialprojek.idProjek))
  return response.data
})

export const putProjekMemberNilai = createAsyncThunk('appInitialProjek/putProjekMemberNilai', async (request, {dispatch, getState}) => {
  const add_url = "member/"
  const add_nilai = "/nilai"
  const response = await axios.put(stat.URL_PROJEK + add_url + request.id + add_nilai, request.payload)
  await dispatch(getProjekMember(getState().initialprojek.idProjek))
  return response.data
})

export const delProjekMember = createAsyncThunk('appInitialProjek/delProjekMember', async (id, {dispatch, getState}) => {
  const add_url = "member/"
  const response = await axios.delete(stat.URL_PROJEK + add_url + id)
  await dispatch(getProjekMember(getState().initialprojek.idProjek))
  return response.data
})

export const delProjek = createAsyncThunk('appInitialProjek/delProjek', async (id, { dispatch, getState }) => {
  const add_url = "del/"
  const response = await axios.delete(stat.URL_MAPEL + add_url + id)
  await dispatch(getProjekByKodeGrade(getState().initialprojek.kodePelajaran))
  return response.data
})

export const appInitialProjekSlice = createSlice({
  name: 'appInitialProjek',
  initialState: {
    grade: {},
    statusLoadGrade: null,
    projek: [],
    statusProjekByKodeGrade: null,
    tema: [],
    statusTemaByKodeGrade: null,
    guru: [],
    statusGuru: null,
    kelas: [],
    idKelas: null,
    statusIdKelas: null,
    selectedProjek: {},
    kodeGrade: null,
    idProjek: null,
    statusPutProjekKeterangan: null, 
    responsePutProjekKeterangan: null,

    statusPutProjekProfil: null, 
    responsePutProjekProfil: null,

    statusProjekDimensiIndikator: null, 
    responseProjekDimensiIndikator: [],

    siswa: [],
    statusGetSiswaList: null,

    projekMember: [],
    statusGetProjekMember: null,

    statusPutProjekMember: null,
    responsePutProjekMember: [],

    statusPutProjekMemberNilai: null,
    responsePutProjekMemberNilai: [],
    
    statusDelProjekMember: null,
    // selectedTask: {},
    params: {
      filter: '',
      q: '',
      sort: '',
      tag: ''
    }
  },
  reducers: {
    selectIdProjek: (state, action) => {
      state.idProjek = action.payload
    },
    selectKodeGrade: (state, action) => {
      state.kodeGrade = action.payload
    },
    selectProjek: (state, action) => {
      state.selectedProjek = action.payload
    },
    stateResetProjek: (state) => {
      state.statusPutProjekKeterangan = "loading"
      state.statusPutProjekProfil = "loading"
      // state.statusGetProjekMember = "loading"
      state.statusPutProjekMember = "loading"
      state.statusDelProjekMember = "loading"
      state.statusPutProjekMemberNilai = "loading"
    },
    stateResetAll: (state) => {
      state.selectedProjek =  {}
      // state.responseProjekDimensiIndikator = []
      state.siswa = []
      state.projekMember = []
    }
  },
  extraReducers: builder => {
    builder.addCase(getGrade.fulfilled, (state, action) => {
      state.grade = action.payload.data
      state.params = action.payload.params
    })
    builder.addCase(getGradeKelas.pending, (state) => {
      state.statusIdKelas = 'loading'
    })
    builder.addCase(getGradeKelas.fulfilled, (state, action) => {      
      state.statusIdKelas = 'loaded'
      state.kelas = action.payload.data
      state.params = action.payload.params
    })
    builder.addCase(getGuru.pending, (state, action) => {
      console.log("loading", action.payload)
      state.statusGuru = 'loading'
    })
    builder.addCase(getGuru.fulfilled, (state, action) => {
      state.statusGuru = 'loaded'
      state.guru = action.payload.data
      state.params = action.payload.params
    })
    builder.addCase(getTemaByKodeGrade.pending, (state, action) => {
      console.log("loading", action.payload)
      state.statusTemaByKodeGrade = 'loading'
    })
    builder.addCase(getTemaByKodeGrade.fulfilled, (state, action) => {
      state.statusTemaByKodeGrade = 'loaded'
      state.tema = action.payload.data
      state.params = action.payload.params
    })
    builder.addCase(getProjekByKodeGrade.pending, (state, action) => {
      console.log("loading", action.payload)
      state.statusProjekByKodeGrade = 'loading'
    })
    builder.addCase(getProjekByKodeGrade.fulfilled, (state, action) => {
      state.statusProjekByKodeGrade = 'loaded'
      state.projek = action.payload.data
      state.params = action.payload.params
    })
    
    // Put Projek Keterangan
    builder.addCase(putProjekKeterangan.pending, (state) => {
      console.log("loading here")
      state.statusPutProjekKeterangan = 'loading'
    })
    builder.addCase(putProjekKeterangan.fulfilled, (state, action) => {
      console.log("loaded here")
      state.statusPutProjekKeterangan = 'loaded'
      state.responsePutProjekKeterangan = action.payload
    })
    builder.addCase(putProjekKeterangan.rejected, (state, action) => {
      state.statusPutProjekKeterangan = 'failed'
      state.responsePutProjekKeterangan = action.error
    })
    // Dimensi Indikator
    builder.addCase(getProjekDimensiIndikator.pending, (state) => {
      console.log("loading here")
      state.statusProjekDimensiIndikator = 'loading'
    })
    builder.addCase(getProjekDimensiIndikator.fulfilled, (state, action) => {
      console.log("loaded here")
      state.statusProjekDimensiIndikator = 'loaded'
      state.responseProjekDimensiIndikator = action.payload.data
    })
    builder.addCase(getProjekDimensiIndikator.rejected, (state, action) => {
      state.statusProjekDimensiIndikator = 'failed'
      state.responseProjekDimensiIndikator = action.error
    })
    // Put Projek Profil
    builder.addCase(putProjekProfil.pending, (state) => {
      console.log("loading here")
      state.statusPutProjekProfil = 'loading'
    })
    builder.addCase(putProjekProfil.fulfilled, (state, action) => {
      console.log("loaded here")
      state.statusPutProjekProfil = 'loaded'
      state.responsePutProjekProfil = action.payload
    })
    builder.addCase(putProjekProfil.rejected, (state, action) => {
      state.statusPutProjekProfil = 'failed'
      state.responsePutProjekProfil = action.error
    })
    // Siswa List
    builder.addCase(getSiswaList.pending, (state) => {
      console.log("loading here")
      state.statusGetSiswaList = 'loading'
    })
    builder.addCase(getSiswaList.fulfilled, (state, action) => {
      console.log("loaded here")
      state.statusGetSiswaList = 'loaded'
      state.siswa = action.payload.data
    })
    builder.addCase(getSiswaList.rejected, (state, action) => {
      state.statusGetSiswaList = 'failed'
      state.siswa = action.error
    })
     //Projek Member
     builder.addCase(getProjekMember.pending, (state) => {
      console.log("loading here")
      state.statusGetProjekMember = 'loading'
    })
    builder.addCase(getProjekMember.fulfilled, (state, action) => {
      console.log("loaded here")
      state.statusGetProjekMember = 'loaded'
      state.projekMember = action.payload.data
    })
    builder.addCase(getProjekMember.rejected, (state, action) => {
      state.statusGetProjekMember = 'failed'
      state.projekMember = action.error
    })
    // Put Projek Member
    builder.addCase(putProjekMember.pending, (state) => {
      console.log("loading here")
      state.statusPutProjekMember = 'loading'
    })
    builder.addCase(putProjekMember.fulfilled, (state, action) => {
      console.log("loaded here")
      state.statusPutProjekMember = 'loaded'
      state.responsePutProjekMember = action.payload
    })
    builder.addCase(putProjekMember.rejected, (state, action) => {
      state.statusPutProjekMember = 'failed'
      state.projekMember = action.error
    })

    // Put Projek Member Nilai
    builder.addCase(putProjekMemberNilai.pending, (state) => {
      console.log("loading here")
      state.statusPutProjekMemberNilai = 'loading'
    })
    builder.addCase(putProjekMemberNilai.fulfilled, (state, action) => {
      console.log("loaded here")
      state.statusPutProjekMemberNilai = 'loaded'
      state.responsePutProjekMemberNilai = action.payload
    })
    builder.addCase(putProjekMemberNilai.rejected, (state) => {
      state.statusPutProjekMemberNilai = 'failed'
    })
    // Delete Projek Member
     builder.addCase(delProjekMember.pending, (state) => {
      console.log("loading here")
      state.statusDelProjekMember = 'loading'
    })
    builder.addCase(delProjekMember.fulfilled, (state) => {
      console.log("loaded here")
      state.statusDelProjekMember = 'loaded'
    })
    builder.addCase(delProjekMember.rejected, (state) => {
      state.statusDelProjekMember = 'failed'
    })
  }
})

export const { selectIdProjek, selectProjek, selectKodeGrade, stateResetProjek, stateResetAll } = appInitialProjekSlice.actions

export default appInitialProjekSlice.reducer
